<template>
  <div
    class="carousel-fifth"
    :style="{
      backgroundImage:
        'url(' + require('@/assets/images/index/carousel-5.jpg') + ')',
    }"
  >
    <div class="carousel-content">
      <div class="carousel-header">
        <div class="header-title">{{ $t("index.food") }}</div>
        <div class="carousel-category">
          <div
            class="category-item"
            :class="params.categoryId === '1838760282269413378' ? 'active' : ''"
            @click="handleTab('1838760282269413378')"
          >
            [{{ $t("all") }}]
          </div>
          <div
            v-for="(item, index) in categoryList"
            :key="index"
            class="category-item"
            :class="params.categoryId === item.id ? 'active' : ''"
            @click="handleTab(item.id)"
          >
            [{{ $t("ajaxKey") ? item[$t("ajaxKey")] : item.title }}]
          </div>
        </div>
      </div>
      <div class="list">
        <div
          v-for="(item, index) in list.slice(0, 4)"
          :key="index"
          class="item"
          @click="toDetail(item)"
        >
          <img class="item-thumb" :src="item.thumb" />
          <div class="item-detail">
            <div class="item-title transition">{{ item.title }}</div>
            <div class="item-tag">
              <div class="tag-item">{{ item.subtitle }}</div>
              <!-- <div class="tag-item">酒店</div> -->
            </div>
            <div class="item-desc">
              {{ item.brief }}
            </div>
          </div>
          <div class="item-btn">
            {{ $t("index.foodDetail") }}
            <img class="btn-icon" src="@/assets/images/index/arrow-white.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { categoryTree, getNewsPage } from "@/api/common";
export default {
  data() {
    return {
      categoryList: [],
      params: {
        categoryId: "1838760282269413378",
      },
      list: [],
    };
  },
  created() {
    categoryTree().then((res) => {
      const data = res.data.find((item) => item.id === "1838760282269413378");
      if (data) {
        this.categoryList = data.children;
      }
    });
    this.init();
  },
  methods: {
    init() {
      getNewsPage(this.params).then((res) => {
        this.list = res.data.records;
      });
    },
    handleTab(categoryId) {
      this.params.categoryId = categoryId;
      this.init();
    },
    toDetail(row) {
      this.$router.push("/strategy/detail?id=" + row.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-fifth {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100%;
  .carousel-content {
    padding-top: 88px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    .carousel-header {
      display: flex;
      flex-direction: column;
      align-items: center;
      .header-title {
        margin-top: 90px;
        color: #fff;
        font-size: 48px;
        font-weight: 700;
        line-height: 26px;
        letter-spacing: 4.32px;
      }
      .carousel-category {
        display: flex;
        margin-top: 36px;
        .category-item {
          color: #fff;
          font-size: 18px;
          font-weight: 400;
          line-height: 26px;
          letter-spacing: 1.62px;
          cursor: pointer;
          &.active {
            font-weight: 700;
          }
          + .category-item {
            margin-left: 32px;
          }
        }
      }
    }
    .list {
      margin-top: 60px;
      width: 1330px;
      display: grid;
      grid-row-gap: 48px;
      grid-column-gap: 48px;
      grid-template-columns: auto auto;
      .item {
        display: flex;
        background: #fff;
        cursor: pointer;
        .item-thumb {
          width: 200px;
          height: 200px;
          object-fit: cover;
        }
        .item-detail {
          flex: 1;
          padding: 20px;
          .item-title {
            color: #222;
            font-size: 20px;
            font-weight: 400;
          }
          .item-tag {
            margin: 12px 0;
            display: flex;
            .tag-item {
              line-height: 22px;
              padding: 0 6px;
              border-radius: 2px;
              background: #f89a00;

              color: #fff;
              font-size: 12px;
              font-weight: 400;
              + .tag-item {
                margin-left: 9px;
              }
            }
          }
          .item-desc {
            overflow: hidden;
            color: #666;

            font-size: 14px;
            font-weight: 400;
            line-height: 26px; /* 185.714% */

            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3; /* 显示的行数，可以根据需要修改 */
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .item-btn {
          width: 51px;
          line-height: 51px;
          text-align: center;
          background: #009d94;
          writing-mode: vertical-rl;
          color: #fff;
          font-size: 18px;
          font-weight: 400;
          .btn-icon {
            margin-top: 12px;
            width: 20px;
          }
        }
        &:hover {
          .item-detail {
            .item-title {
              color: #009d94;
            }
          }
        }
      }
    }
  }
}
</style>
